import { render } from "./CheckResult.vue?vue&type=template&id=01172020"
import script from "./CheckResult.vue?vue&type=script&lang=js"
export * from "./CheckResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__